import { PreviewItemType } from '@dadohr/shared/domainTypes/experiencePreview';
import { ReactNode, useMemo } from 'react';
import { ActorDescriptor } from '../../features/Experiences/components/Actors';
import { UnsafeTFunction, useUnsafeTranslation } from '../../i18next';
import { ChipFilterWithDropdown } from '../ChipFilterWithDropdown';

export const FilterByActorChip = ({
  value,
  onChange,
  actorDescriptors,
  label,
  renderTrigger,
  exclusiveAll
}: {
  value: string[];
  onChange: (nextValue: string[]) => void;
  actorDescriptors: { [actorKey: string]: ActorDescriptor };
  label?: string;
  renderTrigger?: (props: { onClick: () => void }) => ReactNode;
  exclusiveAll?: boolean;
}) => {
  const { t } = useUnsafeTranslation();
  const options = useMemo(
    () =>
      Object.values(actorDescriptors).map((a) => ({
        key: a.key,
        label: a.label
      })),
    [actorDescriptors]
  );

  const selectedActors = useMemo(() => {
    return options.filter((o) => value.includes(o.key));
  }, [options, value]);

  return (
    <ChipFilterWithDropdown
      label={label || `${t('Filter by actor')}`}
      selectedOptions={selectedActors}
      options={options}
      onChange={(xs) => onChange(xs.map((x) => x.key))}
      renderTrigger={renderTrigger}
      exclusiveAll={exclusiveAll}
    />
  );
};

const ITEM_TYPE_OPTIONS = (
  t: UnsafeTFunction
): { key: PreviewItemType; label: string }[] => [
  {
    key: PreviewItemType.MESSAGE,
    label: t('Message')
  },
  {
    key: PreviewItemType.TASK,
    label: t('Task')
  },
  {
    key: PreviewItemType.AUTOMATION,
    label: t('Automation')
  }
];

export const FilterByItemTypeChip = ({
  value,
  onChange,
  label
}: {
  value: PreviewItemType[];
  onChange: (nextValue: PreviewItemType[]) => void;
  label?: string;
}) => {
  const { t } = useUnsafeTranslation();
  const options = useMemo(() => ITEM_TYPE_OPTIONS(t), [t]);

  const selectedItemTYpes = useMemo(
    () => options.filter((o) => value.includes(o.key)),
    [options, value]
  );
  return (
    <ChipFilterWithDropdown
      label={label || `${t('Filter by item type')}`}
      selectedOptions={selectedItemTYpes}
      options={options}
      onChange={(xs) => onChange(xs.map((x) => x.key))}
    />
  );
};
